import { em } from 'polished'
import styled from 'styled-components'
import { H4, Text } from 'styles/components/typography'
import DynamicImage from 'components/DynamicImage'

export const Wrapper = styled.div``
export const ModalContent = styled.div`
  position: relative;
  padding: ${em(40)} ${em(20)} ${em(20)} ${em(20)};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${p => p.theme.mq.upMd} {
    text-align: left;
    align-items: flex-start;
    padding: ${em(60)};
  }
`
export const Grabber = styled.div`
  width: ${em(65)};
  height: ${em(3)};
  border-radius: 2px;
  background-color: ${p => p.theme.colors.blackOp3};
  position: absolute;
  top: ${em(8)};
  left: 50%;
  transform: translate(-50%, 0);
  ${p => p.theme.mq.upMd} {
    display: none;
  }
`

export const Header = styled(H4)`
  padding: 0 ${em(20)};
  ${p => p.theme.mq.upMd} {
    padding: 0;
    margin-bottom: ${em(40)};
  }
`

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${p => p.theme.mq.upMd} {
    flex-direction: row;
    margin-bottom: ${em(40)};
  }
`

export const ImageWrapper = styled.div`
  ${p => p.theme.mq.upMd} {
    margin-right: ${em(30)};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  position: relative;
  display: block;
  max-width: ${em(80)};
  width: ${em(80)};
  height: auto;
  margin: ${em(30)} 0 ${em(10)} 0;
  ${p => p.theme.mq.upMd} {
    margin: 0;
  }
`

export const TextStyled = styled(Text)`
  > span {
    color: ${p => p.theme.colors.purpleHeartDark};
  }
`

export const TextSmall = styled(Text)`
  font-size: 16px;
  > span {
    color: ${p => p.theme.colors.purpleHeartDark};
  }
`

export const Hint = styled.div`
  color: ${p => p.theme.colors.blackOp5};
  padding: ${em(10)};
  margin: ${em(30)} 0 ${em(20)} 0;
  display: flex;
  align-items: center;
  ${p => p.theme.mq.upMd} {
    width: 100%;
    background-color: ${p => p.theme.colors.grayOp06NonTransp};
    border-radius: ${em(20)};
  }
`

export const HintIconWrapper = styled.div`
  flex-shrink: 0;
  width: ${em(20)};
  height: ${em(20)};
  margin-right: ${em(20)};
  ${p => p.theme.mq.upMd} {
    margin-right: ${em(80)};
  }
`

export const ButtonBox = styled.div`
  align-self: stretch;
  > button {
    width: 100%;
  }
  ${p => p.theme.mq.upMd} {
    display: none;
  }
`
export const ButtonContent = styled.div`
  padding: ${em(3)} ${em(22)};
`
